import request from '@/router/axios'

export const getList = (params) => request({
  url: '/api/produce/carbody-holographic/page',
  method: 'get',
  params
})

export const getDetail = (id) => request({
  url: '/api/produce/carbody-holographic/detail',
  method: 'get',
  params: { id }
})
